import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'users-tab-search',
  templateUrl: './users-tab-search.component.html',
  styleUrls: ['./users-tab-search.component.scss']
})
export class UsersTabSearchComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UsersTabSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public search: any) { }

  onApply = new EventEmitter();

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
